import React from 'react';
export default (observer, event) => WrappedComponent => {
    return class extends React.Component {
        render() {
            return <WrappedComponent observer={observer} event={event} {...this.props} />;
        }
    };
};
